// lib
import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { IconButton } from "@material-ui/core";
import { NavigateBefore, NavigateNext } from "@material-ui/icons";

// sub component
const Toolbar = ({ label, onNavigate }) => {
  const { t } = useTranslation();
  return (
    <div className="rbc-toolbar">
      <IconButton
        color="primary"
        onClick={() => onNavigate("PREV")}
        aria-label={t("actions.previous")}
      >
        <NavigateBefore />
      </IconButton>
      <IconButton color="primary" onClick={() => onNavigate("NEXT")} aria-label={t("actions.next")}>
        <NavigateNext />
      </IconButton>
      <span className="rbc-toolbar-label">{label}</span>
    </div>
  );
};

Toolbar.propTypes = {
  // from parent
  label: PropTypes.node.isRequired,
  onNavigate: PropTypes.func.isRequired,
};

export default Toolbar;
